import { Accordion, AccordionDetails, AccordionProps, AccordionSummary, AccordionSummaryProps, Button, Grid, IconButton, styled, Typography, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import makeStyles from '@mui/styles/makeStyles';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { getAdminScores, getFeedback, getMeetings, getStartupDetail, postFeedback } from '../DashBoard/Api';
import Loader from '../../../GlobalComponents/KenLoader';
import { IStartupDetails } from '../Interfaces/IApplicationDetails';
import ApplicationDetails from './ApplicationDetails/index';
import FeedBack from './FeedBack/index';
import AppLayout, { Header } from '../Components/AppLayout';
import storageService from '../../../Utils/storageService';
import wavevector from '../Assets/wavevector.png';
import facebook from '../../Assets/facebook.png';
import twitter from '../../Assets/twitter.png';
import PitchDesk from './PitchDesk';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import FounderTeam from './FounderTeam';
import Notes from './Notes';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import startupBanner from '../Assets/startupBanner.png';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import meetingbanner from '../Assets/pitchDeckBg.png';
import { IAttachment } from '../Interfaces/IForms';
import { debounce } from 'lodash';
import { enqueueSnackbar } from 'notistack';
import moment from 'moment-timezone';
import { FiLink } from 'react-icons/fi';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const useStyles = makeStyles({
  notesMobileButton: {
    position: 'fixed',
    height: '44px',
    width: '44px',
    border: '1px solid #4B3776',
    bottom: '100px',
    right: '22px',
    zIndex: '1',
    background: '#fff',
  },
  averageScoreContainer: {
    background: '#E6E6E6',
    borderRadius: '4px',
    padding: '8px 12px',
    marginRight: '26px',
    '@media (max-width: 600px)': {
      marginRight: '0px',
    },
  },
  averageScoreTag: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
  pitchDeckCard: {
    backgroundImage: `url(${meetingbanner}) !important`,
    backgroundSize: 'cover !important',
    backgroundPosition: 'center !important',
  },
  averageScore: {
    fontSize: '14px !important',
    fontWeight: '600 !important',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
  tabs: {
    fontSize: '14px !important',
    '&.Mui-selected': {
      color: `transparent !important`,
      fontWeight: '500',
      position: 'relative',
    },
  },
  feedBackHeader: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#333333',
  },
  meetName: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#0F0E1F',
    '@media (min-width: 1920px)': {
      fontSize: '18px !important',
    },
  },
  meetDescp: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#8A8A8A',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },
  },
  feedBackContainer: {
    border: '1px solid #E2E2E2',
    boxShadow: '0px 1px 40px 0px #0000000D',
    padding: '20px',
    height: '368px',
    width: '419px',
    gap: '24px',
    position: 'absolute',
    background: 'white',
    borderRadius: '12px',
    bottom: '-20px',
    right: '50px',
    zIndex: '1',
  },
  tab: {
    padding: '20px',
    '& .MuiTabs-flexContainer': {
      gap: '12px',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: `transparent!important`,
    },
    '& .MuiTab-root.Mui-selected': {
      color: `#4b3776 !important`,
      padding: '10px',
      borderRadius: '8px',
      background: '#F2EDFD !important',
    },
    '@media (min-width: 1920px)': {
      padding: '30px',
    },
  },
  cardBgs: {
    borderRadius: '8px',
    border: '1px solid #E6E6E6',
    background: '#fff',
    padding: '15px',
    '@media (min-width: 1920px)': {
      padding: '32px',
    },
  },
  startupLogoCard: {
    border: '1px solid #C6C6C6',
    borderRadius: '3px',
    background: `url(${wavevector})`,
  },
  socialIcons: {
    height: '18px',
    width: '18px',
    borderRadius: '50%',
  },
  notesBtn: {
    // Fixed to the viewport corner (not a percentage of some ancestor's height)
    // so it always floats in the same spot instead of drifting over page content
    // depending on which element ends up establishing its positioning context.
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 1200,
    fontSize: '12px',
    fontWeight: '500',
    maxWidth: '110px',
    '@media (max-width: 1440px)': {
      bottom: '16px',
      right: '16px',
      fontSize: '12px',
    },
  },
  noMeetingText: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#0F0E1F',
    '@media (min-width: 1920px)': {
      fontSize: '16px !important',
    },
  },
  noMeetingDesc: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#8A8A8A',
    width: '50%',
    '@media (min-width: 1920px)': {
      fontSize: '14px !important',
    },
  },
});

const MobileAccordion = styled((props: AccordionProps) => <Accordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
  border: `1px solid #E6E6E6`,
  background: '#fff',
  borderRadius: '12px',
  marginBottom: '8px',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  '&:not(:last-child)': {
    borderBottom: `1px solid #E6E6E6`,
  },
  '&::before': {
    display: 'none',
  },
}));

const MobileAccordionSummary = styled((props: AccordionSummaryProps) => <AccordionSummary expandIcon={<ArrowForwardIosIcon sx={{ fontSize: '0.9rem', color: '#666' }} />} {...props} />)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 1)',
  borderRadius: '12px',
  flexDirection: 'row-reverse',
  padding: '16px',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: '12px',
  },
}));

const MobileAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '16px',
  borderTop: '1px solid #E6E6E6',
  minHeight: '300px',
  backgroundColor: '#fff',
}));

const StartUpsProfile: React.FunctionComponent = (props) => {
  const location:any = useLocation();
  const locationData = location.state?.startupHeader;
  const isEvaluated = location.state?.isEvaluated;
  const tabState = location.state?.tabState || 0;
  // The panel assignment's actual review round (e.g. "Shortlisted") — fixed at
  // assignment time, unlike Application_Status__c which keeps changing as the
  // application progresses. Evaluation questions/scores are looked up by this
  // exact round, so using the live status here caused evaluation to silently
  // disappear once an application moved past its assigned round.
  const assignedReviewRound = location.state?.reviewRound;
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isMaxScreen = useMediaQuery('(max-width:1440px)');
  const { id } = useParams<{ id: string }>();
  const feedBackRef = useRef();
  const navigate = useHistory();
  const [contactId, setContactId] = useState<string>('');
  const [applicationId, setApplicationId] = useState<string>('');
  const [round, setRound] = useState<string>('');
  const [user, setUser] = useState<any>(null);
  // Same isAdmin/isin5admin field VenuePortal already checks for its own admin
  // gating (FacilitiesCart) - same shared user object/login across the SM app.
  const isAdminUser = Boolean(user?.isAdmin || user?.isin5admin);
  const [adminScores, setAdminScores] = useState<any>(null);
  const [adminScoresLoading, setAdminScoresLoading] = useState<boolean>(false);

  // Load contactId and user from storage on component mount
  useEffect(() => {
    const loadStorageData = async () => {
      try {
        const userData = await storageService.getItem('user');
        const contactIdData = userData?.accountId;
        setContactId(contactIdData || '');
        if (userData) {
          setUser(typeof userData === 'string' ? JSON.parse(userData) : userData);
        }
      } catch (error) {
        console.error('Error loading storage data:', error);
      }
    };
    loadStorageData();
  }, []);

  console.log(locationData, isEvaluated, "locationDatalocationData");

  const getStartupData = useQuery({
    // Keyed by `id` so React Query treats each startup as a distinct query —
    // previously the same hardcoded key was reused for every startup, so
    // navigating between two different startup profiles could serve a stale
    // cached result from whichever one was viewed first.
    queryKey: ['getMeeting', id],
    queryFn: async () => {
      if (id) {
        const response: AxiosResponse = await getStartupDetail(id);
        const dataCustomized: any = response?.data?.data.application;
        // Evaluation must show regardless of the application's current status —
        // use the panel assignment's fixed review round (set once, when the jury
        // was assigned, and never changes as the application moves through the
        // pipeline). Never fall back to the live Application_Status__c, which
        // changes over time and was the reason evaluation used to disappear once
        // an application progressed past whatever status it started at.
        // 'Shortlisted' is the fallback only for loads with no assignment context
        // at all (e.g. a direct URL/refresh) — evaluation questionnaires have so
        // far only been found configured under that round.
        const appStatus = assignedReviewRound || 'Shortlisted';
        await storageService.setItem('applicationId', dataCustomized?.Id);
        await storageService.setItem('appStatus', appStatus);
        setApplicationId(dataCustomized?.Id || '');
        setRound(appStatus);
        const recordIds = (response?.data?.data.attachments || []).map((item: IAttachment, index: number) => ({
          recordId: item?.Submitted_File_Id__c,
          Title: item?.Title,
          fileName: item?.fileName,
        }));

        const DataCustomize: IStartupDetails = {
          Applicant__c: dataCustomized?.Applicant__c,
          Application_Status__c: dataCustomized?.Application_Status__c,
          Business_Engagement_Model__c: dataCustomized?.Business_Engagement_Model__c,
          Competitors__c: dataCustomized?.Competitors__c,
          CurrencyIsoCode: dataCustomized?.CurrencyIsoCode,
          Id: dataCustomized?.Id,
          Name: dataCustomized?.Name,
          Revenue_Generated__c: dataCustomized?.Revenue_Generated__c,
          Sector__c: dataCustomized?.Sector__c,
          Startup_Application_Form__c: dataCustomized?.Startup_Application_Form__c,
          Startup_Name__c: dataCustomized?.Startup_Name__c,
          Startup_Website_URL__c: dataCustomized?.Startup_Website_URL__c,
          SystemModstamp: dataCustomized?.SystemModstamp,
          Company_Sypnosis__c: dataCustomized?.Company_Sypnosis__c,
          Elevator_Pitch__c: dataCustomized?.Elevator_Pitch__c,
          Registered_Address__City__s: dataCustomized?.Registered_Address__City__s,
          Registered_Address__CountryCode__s: dataCustomized?.Registered_Address__CountryCode__s,
          Registered_Address__PostalCode__s: dataCustomized?.Registered_Address__PostalCode__s,
          Registered_Address__Street__s: dataCustomized?.Registered_Address__Street__s,
          URL_of_your_Website_App_Video__c: dataCustomized?.URL_of_your_Website_App_Video__c,
        };

        const additionalDoc = response?.data?.data?.attachments.filter((item: { Document_Type__c: any }) => item.Document_Type__c === 'Pitch Deck');
        setNotes(dataCustomized?.Notes__c);
        setAdditionalDocuments(additionalDoc);
        setFoundersData(response?.data?.data?.teamMembers);

        return { DataCustomize, recordIds };
      }
    },
    refetchOnWindowFocus: false,
  });

  const handleClick = () => {
    if (feedBackRef.current) {
      (feedBackRef.current as any)?.handleSubmit('submit');
    }
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // Feedback popup
  const [additionalDocs, setAdditionalDocuments] = useState<any>();
  const [notes, setNotes] = useState<string | null>(null);
  const [founderData, setFoundersData] = useState<Array<any>>([]);
  const [tabValue, setTabValue] = useState<number>(() => {
    // Convert desktop tab index to mobile tab index for evaluation
    if (tabState === 3 && isMobile) {
      return 0; // Evaluation tab is at index 0 in mobile
    }
    return tabState;
  });
  const [feedBackForm, setFeedBackForm] = useState<boolean>(false);
  const [expanded, setExpanded] = React.useState<string | false>('panel1');
  const [companyExpanded, setCompanyExpanded] = React.useState<boolean>(false);
  const [trigger, settriggger] = useState<number>(0);
  const [avgScore, setAvgScore] = useState<any>();
  const [pitchDesk, setPitchDesk] = useState<any>();
  // Lifted from FeedBack so the Save/Submit buttons can render up here, in
  // this page's own tab-header row (next to the Average score badge) instead
  // of a separate bar/floating element local to FeedBack.
  const [evaluted, setEvaluated] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const debouncedSetTrigger = useCallback(
    debounce(() => {
      settriggger((prev) => prev + 1);
    }, 1500),
    []
  );

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleFeedBackForm = () => {
    setFeedBackForm(!feedBackForm);
  };

  const handleTabs = (e: React.SyntheticEvent<Element>, value: number) => {
    setTabValue(value);
  };

  const handleNotes = (value: string) => {
    setNotes(value);
    debouncedSetTrigger();
  };

  useEffect(() => {
    if (trigger > 0) {
      postFeedback({
        applicationId: id,
        notes: notes,
      })
        .then((res) => {
          if (res.data) {
            setNotes(res.data?.Notes__c);
            settriggger(0);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }

    return () => {
      debouncedSetTrigger.cancel();
    };
  }, [trigger, id]);

  useEffect(() => {
    if (contactId && applicationId && round) {
      getFeedback(contactId, applicationId, round)
        .then((response) => {
          if (response) {
            if (response?.data?.data?.feedbackScore?.evaluated == true) {
              const raw = response?.data?.data?.feedbackScore?.avgScore;
              setAvgScore(raw !== null && raw !== undefined ? Number(raw).toFixed(2) : raw);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [contactId, applicationId, round]); // Add dependencies

  // Every juror's individual score for this application, for the admin-only
  // tab below. Only fetched for an admin - a regular jury member's own
  // evaluation view (FeedBack, above) never sees other jurors' scores.
  useEffect(() => {
    if (isAdminUser && applicationId && round) {
      setAdminScoresLoading(true);
      getAdminScores(applicationId, round)
        .then((response) => {
          // Node's apexSuccess sends the Apex response body straight through, so
          // axios's own response.data IS that body: { success, data: {...} } -
          // one level, not two (unlike some other jury endpoints whose Apex body
          // nests an extra "data" inside .data).
          if (response?.data?.success) {
            setAdminScores(response.data.data);
          }
        })
        .catch((err) => {
          console.error('Error loading admin scores:', err);
        })
        .finally(() => {
          setAdminScoresLoading(false);
        });
    }
  }, [isAdminUser, applicationId, round]);

  useEffect(() => {
    if (user?.accountId && id) {
      getMeetings(user.accountId)
        .then((res) => {
          if (res.data.success) {
            const meetings = res.data.data?.meetings || [];
            const getMeeting = meetings.find((items: any) => {
              return items?.Application__c === id;
            });
            setPitchDesk(getMeeting);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [user, id]); // Add dependencies

  const handleTabPanels = (tab: number) => {
    switch (tab) {
      case 0:
        return <FounderTeam founderTeam={founderData} />;
      case 1:
        return <ApplicationDetails id={`${id}`} data={getStartupData?.data} />;
      case 2:
        return <PitchDesk recordId={getStartupData?.data?.recordIds?.[0]?.recordId} />;
      case 3:
        return <FeedBack avgScore={avgScore} setAvgScore={setAvgScore} evaluted={evaluted} setEvaluted={setEvaluated} isSubmitting={isSubmitting} setIsSubmitting={setIsSubmitting} startUpDetails={`${id}`} applicationId={applicationId} contactId={contactId} round={round} ref={feedBackRef} />;
      case 4:
        return <Notes notes={notes} handleNotes={handleNotes} />;
      case 5:
        return <AdminScoresPanel scores={adminScores} loading={adminScoresLoading} />;
      default:
        return null;
    }
  };

  const AdminScoresPanel: React.FunctionComponent<{ scores: any; loading: boolean }> = ({ scores, loading }) => {
    if (loading) {
      return <Typography color={'#666'} fontSize={'13px'}>Loading scores...</Typography>;
    }
    if (!scores) {
      return <Typography color={'#666'} fontSize={'13px'}>No scoring data available yet.</Typography>;
    }
    const jurorScores = scores?.jurorScores || [];
    return (
      <Box component={'div'} className="d-flex flex-column" gap={'20px'}>
        <Box component={'div'} className="d-flex flex-wrap" gap={'24px'}>
          <Box component={'div'}>
            <Typography color={'#666'} fontSize={'12px'}>Review status</Typography>
            <Typography color={'#333'} fontSize={'14px'} fontWeight={600}>
              {scores?.isReviewComplete ? 'Complete' : 'In progress'}
            </Typography>
          </Box>
          <Box component={'div'}>
            <Typography color={'#666'} fontSize={'12px'}>Average evaluation score</Typography>
            <Typography color={'#333'} fontSize={'14px'} fontWeight={600}>
              {scores?.averageEvaluationScore !== null && scores?.averageEvaluationScore !== undefined ? `${Number(scores.averageEvaluationScore).toFixed(2)}/5` : '—'}
            </Typography>
          </Box>
          <Box component={'div'}>
            <Typography color={'#666'} fontSize={'12px'}>Selected evaluation score</Typography>
            <Typography color={'#333'} fontSize={'14px'} fontWeight={600}>
              {scores?.selectedEvaluationScore !== null && scores?.selectedEvaluationScore !== undefined ? `${Number(scores.selectedEvaluationScore).toFixed(2)}/5` : '—'}
            </Typography>
          </Box>
        </Box>
        <Box component={'div'} className="d-flex flex-column" gap={'8px'}>
          <Typography color={'#333'} fontSize={'14px'} fontWeight={600}>Jury members</Typography>
          {jurorScores.length === 0 && (
            <Typography color={'#666'} fontSize={'13px'}>No jury members assigned yet.</Typography>
          )}
          {jurorScores.map((juror: any, index: number) => (
            <Box
              key={juror?.memberId || index}
              component={'div'}
              className="d-flex align-items-center justify-content-between"
              sx={{ padding: '10px 12px', borderRadius: '8px', background: '#F6F8FB', opacity: juror?.isEligible === false ? 0.6 : 1 }}
            >
              <Box component={'div'} className="d-flex flex-column">
                <Typography color={'#333'} fontSize={'13px'} fontWeight={500}>
                  {juror?.memberName || 'Unknown juror'}
                  {juror?.isEligible === false ? ' (not eligible)' : ''}
                </Typography>
                <Typography color={'#666'} fontSize={'12px'}>
                  {juror?.evaluated
                    ? `Submitted${juror?.evaluatedDateTime ? ` on ${moment(juror.evaluatedDateTime).format('DD MMM YYYY, h:mm A')}` : ''}`
                    : 'Not yet evaluated'}
                </Typography>
              </Box>
              <Typography color={'#4B3776'} fontSize={'14px'} fontWeight={600}>
                {juror?.avgScore !== null && juror?.avgScore !== undefined ? `${Number(juror.avgScore).toFixed(2)}/5` : '—'}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  return getStartupData.isLoading || getStartupData.isError ? (
    <Loader />
  ) : isMobile ? (
    <Box component={'div'} sx={{ minHeight: '100vh' }}>
      {/* <Box component={'img'} src={startupBanner} width={'100%'} height={'140px'} sx={{ position: 'absolute', zIndex: '-1', width: '100%' }} /> */}
      {/* <IconButton
        className={classes.notesMobileButton}
        onClick={() => {
          navigate.push(`/notes/${id}`);
        }}
      >
        <EditOutlinedIcon sx={{ height: '20px', width: '20px', color: '#4B3776' }} />
      </IconButton> */}
      <Box component={'div'} className="d-flex flex-column w-100" gap={'20px'} marginBottom={'80px'}>
        {/* <Header /> */}
        
        {/* Company Header Section */}
        <Box component={'div'} sx={{ 
          borderRadius: '0px', 
          padding: '0px', 
          border: 'none',
          borderBottom: '1px solid #D1C8E3'
        }}>
          {/* Clickable Header */}
          <Box 
            component={'div'} 
            className="d-flex align-items-center" 
            gap={'16px'} 
            padding={'16px'}
            onClick={() => setCompanyExpanded(!companyExpanded)}
            sx={{ cursor: 'pointer' }}
          >
            {/* Company Logo */}
            <Box component={'div'} sx={{
              width: '60px',
              height: '60px',
              borderRadius: '8px',
              border: '1px solid #E6E6E6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f8f9fa',
              flexShrink: 0
            }}>
              <Typography fontSize={'24px'} fontWeight={'600'} color={'#4B3776'}>
                {(getStartupData?.data?.DataCustomize?.Startup_Name__c || locationData?.Name_of_Product_or_Startup_Venture__c || 'N/A')
                  .split(' ')
                  .map((word: string) => word.charAt(0))
                  .join('')
                  .substring(0, 2)
                  .toUpperCase()}
              </Typography>
            </Box>
            
            {/* Company Info */}
            <Box component={'div'} className="d-flex flex-column justify-content-center" sx={{ flex: 1 }}>
              <Typography 
                sx={{
                  fontFamily: 'General Sans',
                  fontSize: '14px',
                  fontWeight: 500,
                  lineHeight: '140%',
                  color: '#333333'
                }}
              >
                {getStartupData?.data?.DataCustomize?.Startup_Name__c || locationData?.Name_of_Product_or_Startup_Venture__c || 'N/A'}
              </Typography>
              <Box component={'div'} className="d-flex align-items-center" gap={'24px'} marginTop={'8px'}>
                <Box component={'div'} sx={{ minWidth: 0, flexShrink: 1 }}>
                  <Typography
                    sx={{
                      color: '#8C8E94',
                      fontFamily: 'General Sans',
                      fontWeight: 500,
                      fontSize: '12px',
                      lineHeight: '140%',
                      letterSpacing: '0%'
                    }}
                  >
                    Location
                  </Typography>
                    <Typography
                    sx={{
                      fontFamily: 'General Sans',
                      fontWeight: 500,
                      fontSize: '12px',
                      lineHeight: '140%',
                      letterSpacing: '0%',
                      color: '#373A45',
                      wordBreak: 'break-word'
                    }}
                    >
                    {getStartupData?.data?.DataCustomize?.Registered_Address__City__s ||
                     locationData?.Registered_Address__City__s || 'N/A'}
                    </Typography>
                </Box>
                <Box component={'div'} sx={{ minWidth: 0, flex: 1, flexShrink: 1 }}>
                    <Typography
                    sx={{
                      color: '#8C8E94',
                      fontFamily: 'General Sans',
                      fontWeight: 500,
                      fontSize: '12px',
                      lineHeight: '140%',
                      letterSpacing: '0%'
                    }}
                    >
                    Website
                    </Typography>
                    <Typography
                    sx={{
                      fontFamily: 'General Sans',
                      fontWeight: 500,
                      fontSize: '12px',
                      lineHeight: '140%',
                      letterSpacing: '0%',
                      color: '#373A45',
                      wordBreak: 'break-all'
                    }}
                    >
                    {getStartupData?.data?.DataCustomize?.Startup_Website_URL__c ||
                     locationData?.URL_of_your_Website_App_Video__c || 'N/A'}
                    </Typography>
                </Box>
              </Box>
            </Box>
            
            {/* Dropdown Arrow */}
            <ArrowForwardIosIcon sx={{ 
              fontSize: '16px', 
              color: '#666', 
              transform: companyExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease'
            }} />
          </Box>
          
          {/* Expandable Content */}
          {companyExpanded && (
            <Box component={'div'} padding={'0px 16px 16px 16px'}>
              {/* Additional Info Row */}
              <Box component={'div'} className="d-flex align-items-center justify-content-between" marginTop={'16px'}>
                <Box component={'div'}>
                  <Typography fontSize={'12px'} fontWeight={'500'} color={'#8C8E94'}>
                    Sector
                  </Typography>
                  <Typography fontSize={'14px'} fontWeight={'500'} color={'#373A45'}>
                    {(getStartupData?.data?.DataCustomize?.Sector__c || 
                      (locationData?.Indicate_industry_you_are_serving__c && locationData?.Industry__c
                        ? `${locationData?.Indicate_industry_you_are_serving__c}, ${locationData?.Industry__c}`
                        : locationData?.Indicate_industry_you_are_serving__c || locationData?.Industry__c)) || 'N/A'}
                  </Typography>
                </Box>
                <Box component={'div'} className="d-flex align-items-center" gap={'8px'}>
                  <Typography fontSize={'12px'} fontWeight={'500'} color={'#8C8E94'}>
                    Social Connect
                  </Typography>
                  <Box component={'div'} className="d-flex" gap={'8px'}>
                    {(getStartupData?.data?.DataCustomize?.Startup_Website_URL__c || locationData?.URL_of_your_Website_App_Video__c) && (
                      <Box 
                        component={'div'} 
                        sx={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          backgroundColor: '#0A66C2',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer'
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const url = getStartupData?.data?.DataCustomize?.Startup_Website_URL__c || locationData?.URL_of_your_Website_App_Video__c;
                          if (url) {
                            window.open(url.startsWith('http') ? url : `https://${url}`, '_blank');
                          }
                        }}
                      >
                        <FiLink color="#fff" size={'12px'} />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
              
              {/* Elevator Pitch */}
              <Box component={'div'} marginTop={'16px'}>
                <Typography fontSize={'12px'} fontWeight={'500'} color={'#8C8E94'} marginBottom={'4px'}>
                  Elevator Pitch
                </Typography>
                <Typography fontSize={'14px'} fontWeight={'400'} color={'#373A45'} lineHeight={'1.4'}>
                  {getStartupData?.data?.DataCustomize?.Elevator_Pitch__c || 
                   locationData?.Product_Service_Outline_in_one_statement__c || 
                   getStartupData?.data?.DataCustomize?.Company_Sypnosis__c || 'No elevator pitch available'}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        {/* Tab Sections */}
        <Box component={'div'} sx={{ 
          background: '#fff', 
          borderRadius: '0px', 
          boxShadow: 'none',
          border: 'none',
          overflow: 'hidden'
        }}>
          <Tabs
            value={tabValue}
            onChange={handleTabs}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              borderBottom: '1px solid #E6E6E6',
              '& .MuiTabs-flexContainer': {
                gap: '0px',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#4B3776',
                height: '3px',
              },
              '& .MuiTab-root': {
                fontSize: '12px',
                fontWeight: '500',
                color: '#666',
                textTransform: 'none',
                minWidth: 'auto',
                padding: '12px 16px',
                '&.Mui-selected': {
                  color: '#4B3776',
                  fontWeight: '600',
                },
              },
            }}
          >
            <Tab label="Evaluation" {...a11yProps(0)} />
            <Tab label="Founder & Team" {...a11yProps(1)} />
            <Tab label="Application Details" {...a11yProps(2)} />
            <Tab label="Pitch Deck" {...a11yProps(3)} />
            <Tab label="Notes" {...a11yProps(4)} />
            {isAdminUser && <Tab label="Admin Scores" {...a11yProps(5)} />}
          </Tabs>

          <Box component={'div'} sx={{ padding: '16px', minHeight: '400px' }}>
            {tabValue === 0 && (
              <Box component={'div'}>
                {avgScore && (
                  <Box component={'div'} className={`d-flex align-items-center justify-content-end ${classes.averageScoreContainer}`} sx={{ marginBottom: '16px' }}>
                    <Typography component={'h6'} className={classes.averageScoreTag}>
                      Average:
                    </Typography>
                    <Typography component={'h6'} className={classes.averageScore}>
                      {avgScore}/5
                    </Typography>
                  </Box>
                )}
                <FeedBack avgScore={avgScore} setAvgScore={setAvgScore} evaluted={evaluted} setEvaluted={setEvaluated} isSubmitting={isSubmitting} setIsSubmitting={setIsSubmitting} ref={feedBackRef} startUpDetails={`${id}`} applicationId={applicationId} contactId={contactId} round={round} />
              </Box>
            )}
            {tabValue === 1 && <FounderTeam founderTeam={founderData} />}
            {tabValue === 2 && <ApplicationDetails id={`${id}`} data={getStartupData?.data} />}
            {tabValue === 3 && <PitchDesk recordId={getStartupData?.data?.recordIds?.[0]?.recordId} />}
            {tabValue === 4 && <Notes notes={notes} handleNotes={handleNotes} />}
            {tabValue === 5 && isAdminUser && <AdminScoresPanel scores={adminScores} loading={adminScoresLoading} />}
          </Box>
        </Box>
      </Box>
      
      {/* Fixed Bottom Section */}
      <Box component={'div'} className="w-100 d-flex align-items-center bg-white" gap={'8px'} padding={'16px'} position={'fixed'} left={'0px'} bottom={'60px'} sx={{ 
        borderTop: '1px solid #E6E6E6',
        boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.08)'
      }}>
        {tabValue === 0 ? (
          !isEvaluated ? (
            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{ 
                backgroundColor: '#4B3776',
                '&:hover': { backgroundColor: '#3d2d61' },
                borderRadius: '8px',
                fontWeight: '600'
              }}
              onClick={() => {
                handleClick();
              }}
            >
              Submit
            </Button>
          ) : null
        ) : (
          <>
            <Button 
              variant="outlined" 
              sx={{ 
                borderColor: '#E6E6E6', 
                color: '#4B3776', 
                fontWeight: '500',
                borderRadius: '8px'
              }} 
              fullWidth 
              size="large"
            >
              Join Meeting
            </Button>
            {!isEvaluated && (
              <Button
                variant="contained"
                fullWidth
                size="large"
                sx={{ 
                  backgroundColor: '#4B3776',
                  '&:hover': { backgroundColor: '#3d2d61' },
                  borderRadius: '8px',
                  fontWeight: '600'
                }}
                endIcon={<ArrowForwardIosIcon />}
                onClick={() => {
                  setTabValue(0);
                }}
              >
                Begin Evaluation
              </Button>
            )}
          </>
        )}
      </Box>
    </Box>
  ) : (
    <AppLayout useParentWidth>
      {feedBackForm && (
        <Box component={'div'} className={`d-flex flex-column ${classes.feedBackContainer}`}>
          <Box component={'div'} className="d-flex justify-content-between align-items-center">
            <Typography className={classes.feedBackHeader}>Notes</Typography>
            <IconButton
              onClick={() => {
                handleFeedBackForm();
              }}
            >
              <CancelIcon />
            </IconButton>
          </Box>
          <textarea
            style={{ height: '100%', width: '100%', resize: 'none', border: 'none', padding: '12px', color: '#333333', fontSize: '14px' }}
            value={notes || ''}
            onChange={(e) => {
              handleNotes(e.target.value);
            }}
          />
        </Box>
      )}
      <Grid container spacing={3} alignItems={'stretch'}>
        <Grid item lg={7}>
          <Box component={'div'} className={`${classes.cardBgs} d-flex align-items-start justify-content-between w-100`}>
            <Grid container spacing={4} alignItems={'center'}>
              <Grid item container lg={0.5} spacing={1} >
                <ArrowBackIcon
                  style={{ width: 18, cursor: "pointer", zIndex: 1, marginTop: -45, marginLeft: isMaxScreen ? 8 : 4 }}
                  onClick={() => navigate.goBack()}
                />
              </Grid>
              <Grid item container lg={10} spacing={1}>
                <Grid item lg={12}>
                  <Typography fontSize={isMaxScreen ? '14px' : '18px'} fontWeight={'600'} color={'#000000'}>
                    {locationData?.Name_of_Product_or_Startup_Venture__c || '-'}
                  </Typography>
                </Grid>
                <Grid item lg={2.25}>
                  <Box component={'div'} className="d-flex flex-column" gap={'2px'}>
                    <Typography fontSize={isMaxScreen ? '11px' : '13px'} fontWeight={'500'} color={'#8C8E94'}>
                      Location
                    </Typography>
                    <Typography fontSize={isMaxScreen ? '12px' : '14px'} fontWeight={'500'} color={'#373A45'}>
                      Bangalore
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={3}>
                  <Box component={'div'} className="d-flex flex-column" gap={'2px'}>
                    <Typography fontSize={isMaxScreen ? '11px' : '13px'} fontWeight={'500'} color={'#8C8E94'}>
                      Sector
                    </Typography>
                    <Typography fontSize={isMaxScreen ? '12px' : '14px'} fontWeight={'500'} color={'#373A45'}>
                      {(locationData?.Indicate_industry_you_are_serving__c && locationData?.Industry__c
                        ? `${locationData?.Indicate_industry_you_are_serving__c}, ${locationData?.Industry__c}`
                        : locationData?.Indicate_industry_you_are_serving__c || locationData?.Industry__c) || '-'}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={2.25} sx={{ minWidth: 0 }}>
                  <Box component={'div'} className="d-flex flex-column" gap={'2px'} sx={{ minWidth: 0 }}>
                    <Typography fontSize={isMaxScreen ? '11px' : '13px'} fontWeight={'500'} color={'#8C8E94'}>
                      Website
                    </Typography>
                    <Typography fontSize={isMaxScreen ? '12px' : '14px'} fontWeight={'500'} color={'#373A45'} sx={{ wordBreak: 'break-all' }}>
                      {locationData?.URL_of_your_Website_App_Video__c || '-'}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item lg={2.25}>
                  <Box component={'div'} className="d-flex flex-column" gap={'4px'}>
                    <Typography fontSize={isMaxScreen ? '11px' : '13px'} fontWeight={'500'} color={'#8C8E94'}>
                      Social Connect
                    </Typography>
                    <Box
                      component={'div'}
                      sx={{ background: '#0A66C2', width: '100%', borderRadius: '4px', maxWidth: '20px', padding: '4px' }}
                      className="d-flex flex-column align-items-center justify-content-center"
                      onClick={() => {
                        window.open(`https://${getStartupData.data?.DataCustomize?.URL_of_your_Website_App_Video__c}`, '_blank');
                      }}
                    >
                      <FiLink color="#fff" size={'10px'} />
                    </Box>
                  </Box>
                </Grid>
                <Grid item lg={2.25}>
                  <Box component={'div'} className="d-flex flex-column" gap={'4px'}>
                    {!isEvaluated && (
                      <Button
                        variant="contained"
                        sx={{ width: isMaxScreen ? '150px' : '180px', height: isMaxScreen ? '30px' : '40px', fontSize: isMaxScreen ? '12px' : '14px', fontWeight: '500' }}
                        onClick={() => {
                          setTabValue(3);
                        }}
                      >
                        Begin evaluation
                      </Button>
                    )}
                  </Box>
                </Grid>

                <Grid item lg={12}>
                  <Box component={'div'} className="d-flex flex-column" gap={'4px'}>
                    <Typography fontSize={isMaxScreen ? '11px' : '13px'} fontWeight={'500'} color={'#8C8E94'}>
                      Elevator Pitch
                    </Typography>
                    <Typography fontSize={isMaxScreen ? '12px' : '14px'} fontWeight={'500'} color={'#373A45'}>
                      {locationData?.Product_Service_Outline_in_one_statement__c}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

          </Box>
        </Grid>
        <Grid item lg={3}>
          <Box component={'div'} className={`${classes.cardBgs} ${classes.pitchDeckCard} d-flex flex-column justify-content-between w-100 h-100`}>
            {pitchDesk ? (
              <>
                <Box component={'div'} className="d-flex flex-column" gap={'4px'}>
                  <Typography className={classes.meetName}>Pitch Meeting</Typography>
                  <Typography className={classes.meetDescp} width={'50%'}>
                    {pitchDesk?.Name}
                  </Typography>
                  <Typography className={classes.meetDescp} width={'50%'}>
                    Date: {moment(pitchDesk?.Start_Date_Time__c).format('Do MMMM YYYY')}
                  </Typography>
                  <Typography className={classes.meetDescp} width={'50%'}>
                    Time: {moment(pitchDesk?.Start_Date_Time__c).format('h:mm A')} {moment().tz(moment.tz.guess()).format('z')}
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ fontSize: isMaxScreen ? '10px' : '12px', fontWeight: '500', width: isMaxScreen ? '100px' : '150px', height: isMaxScreen ? '30px' : '40px' }}
                  endIcon={<VideocamOutlinedIcon />}
                  onClick={() => {
                    window.open(pitchDesk?.Meeting_Link__c, '_blank');
                  }}
                >
                  Join meeting
                </Button>
              </>
            ) : (
              <Box component={'div'} className="d-flex flex-column" gap={'5px'} style={{height:"118px"}}>
                <Typography className={classes.noMeetingText}>No meeting</Typography>
                <Typography className={classes.noMeetingDesc}>You'll see a pitch presentation meeting here</Typography>
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box component={'div'} minHeight={isMaxScreen ? '500px' : '450px'} className={classes.cardBgs} sx={{ padding: '0px !important', display: 'flex', flexDirection: 'column' }}>
            <Box
              component={'div'}
              className="w-100 d-flex align-items-center justify-content-between"
              // Tabs variant="scrollable" plus the Average badge/Save/Submit
              // buttons together can exceed the row's width without actually
              // triggering the Tabs' own internal scroll - flexShrink:0 alone
              // just meant the row itself overflowed past the viewport edge
              // instead. Wrapping drops the buttons to their own line instead
              // of requiring the whole page to shrink to bring them into view.
              sx={{ flexWrap: 'wrap', rowGap: '8px' }}
            >
              <Tabs
                variant="scrollable"
                value={tabValue}
                className={classes.tab}
                // Forces Tabs to respect the row's available width instead of
                // reporting its full natural content width to the flex parent
                // - "scrollable" only scrolls internally once it's actually
                // bounded like this; without it, the parent never saw a
                // reason to wrap, and this sibling's content (Average badge +
                // Save/Submit) just got pushed off past the visible edge.
                sx={{ flex: '1 1 auto', minWidth: 0 }}
                onChange={(e, value) => {
                  handleTabs(e, value);
                }}
              >
                <Tab
                  sx={{ height: '20px' }}
                  label={
                    <Box component={'div'} className="d-flex align-items-center gap-2">
                      <ArticleOutlinedIcon style={{ width: isMaxScreen ? '20px' : '30px' }} />
                      <Typography component={'h6'} fontSize={isMaxScreen ? '10px' : '12px'} fontWeight={'500'}>
                        Founder & Team
                      </Typography>
                    </Box>
                  }
                  {...a11yProps(0)}
                  className={`text-capitalize ${classes.tabs}`}
                />
                <Tab
                  label={
                    <Box component={'div'} className="d-flex align-items-center gap-2">
                      <SmsOutlinedIcon style={{ width: isMaxScreen ? '20px' : '30px' }} />
                      <Typography component={'h6'} fontSize={isMaxScreen ? '10px' : '12px'} fontWeight={'500'}>
                        Application Details
                      </Typography>
                    </Box>
                  }
                  {...a11yProps(1)}
                  className={`text-capitalize ${classes.tabs}`}
                />
                <Tab
                  label={
                    <Box component={'div'} className="d-flex align-items-center gap-2">
                      <ArticleOutlinedIcon style={{ width: isMaxScreen ? '20px' : '30px' }} />
                      <Typography component={'h6'} fontSize={isMaxScreen ? '10px' : '12px'} fontWeight={'500'}>
                        Pitch Deck
                      </Typography>
                    </Box>
                  }
                  {...a11yProps(2)}
                  className={`text-capitalize ${classes.tabs}`}
                />
                <Tab
                  label={
                    <Box component={'div'} className="d-flex align-items-center gap-2">
                      <EmojiEventsOutlinedIcon style={{ width: isMaxScreen ? '20px' : '30px' }} />
                      <Typography component={'h6'} fontSize={isMaxScreen ? '10px' : '12px'} fontWeight={'500'}>
                        Evaluation
                      </Typography>
                    </Box>
                  }
                  {...a11yProps(4)}
                  className={`text-capitalize ${classes.tabs}`}
                />
                <Tab
                  label={
                    <Box component={'div'} className="d-flex align-items-center gap-2">
                      <ModeEditOutlineOutlinedIcon style={{ width: isMaxScreen ? '20px' : '30px' }} />
                      <Typography component={'h6'} fontSize={isMaxScreen ? '10px' : '12px'} fontWeight={'500'}>
                        Notes
                      </Typography>
                    </Box>
                  }
                  {...a11yProps(5)}
                  className={`text-capitalize ${classes.tabs}`}
                />
                {isAdminUser && (
                  <Tab
                    label={
                      <Box component={'div'} className="d-flex align-items-center gap-2">
                        <EmojiEventsOutlinedIcon style={{ width: isMaxScreen ? '20px' : '30px' }} />
                        <Typography component={'h6'} fontSize={isMaxScreen ? '10px' : '12px'} fontWeight={'500'}>
                          Admin Scores
                        </Typography>
                      </Box>
                    }
                    {...a11yProps(6)}
                    className={`text-capitalize ${classes.tabs}`}
                  />
                )}
              </Tabs>
            </Box>
            {tabValue === 3 && (
              // Its own row below the tabs, not squeezed into the same row as
              // Tabs variant="scrollable" - that row (Tabs + this content)
              // never reliably fit together: Tabs doesn't report a shrunk
              // width to the flex parent, so wrapping/reordering there just
              // moved which piece got cut off rather than fixing it. A
              // separate row guarantees all three controls stay visible
              // regardless of how much space the tabs themselves need.
              <Box
                component={'div'}
                className="d-flex align-items-center justify-content-end"
                gap={'16px'}
                sx={{
                  padding: '8px 20px 0px 20px',
                  // Restructuring this row twice (competing with Tabs, then
                  // its own row, then reordering) never actually stopped
                  // something from clipping its right edge - width:100% was
                  // likely stretching to match an over-wide ancestor rather
                  // than the visible viewport. overflowX:auto guarantees the
                  // Submit button is reachable regardless of that root cause.
                  overflowX: 'auto',
                  maxWidth: '100%',
                }}
              >
                {!isEvaluated && (
                  evaluted ? (
                    <Button
                      variant="outlined"
                      size="small"
                      disabled
                      sx={{ borderRadius: '8px', fontSize: '12px', fontWeight: '500', color: '#008221', borderColor: '#DBDBDB', flexShrink: 0 }}
                    >
                      Submitted
                    </Button>
                  ) : (
                    <Box component={'div'} className="d-flex align-items-center" gap={'16px'} sx={{ flexShrink: 0 }}>
                      <Typography
                        component={'h6'}
                        onClick={() => {
                          if (!isSubmitting) {
                            (feedBackRef.current as any)?.handleSubmit('save');
                          }
                        }}
                        sx={{
                          fontSize: '12px',
                          fontWeight: '500',
                          color: '#333333',
                          cursor: 'pointer',
                          opacity: isSubmitting ? 0.6 : 1,
                          pointerEvents: isSubmitting ? 'none' : 'auto',
                        }}
                      >
                        Save as draft
                      </Typography>
                      <Button
                        variant="contained"
                        size="small"
                        disabled={isSubmitting}
                        sx={{ borderRadius: '8px', fontSize: '12px', fontWeight: '500' }}
                        onClick={() => (feedBackRef.current as any)?.handleSubmit('submit')}
                      >
                        Submit
                      </Button>
                    </Box>
                  )
                )}
                <Box component={'div'} className={`h-100 d-flex align-items-center ${classes.averageScoreContainer}`}>
                  <Typography component={'h6'} className={classes.averageScoreTag}>
                    Average:
                  </Typography>
                  <Typography component={'h6'} className={classes.averageScore}>
                    {avgScore}/5
                  </Typography>
                </Box>
              </Box>
            )}
            <div className="w-100" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: '350px' }}>
              {handleTabPanels(tabValue)}
              {tabValue !== 4 &&
                createPortal(
                  <Button
                    onClick={() => {
                      handleFeedBackForm();
                    }}
                    size="small"
                    variant="contained"
                    className={classes.notesBtn}
                    startIcon={<EditOutlinedIcon />}
                    sx={{
                      // sx always wins the MUI v5 cascade, unlike the @mui/styles (JSS)
                      // class above, whose stylesheet can lose the ordering battle once
                      // this button is portaled outside its usual place in the tree.
                      position: 'fixed !important',
                      bottom: '90px',
                      right: '24px',
                      zIndex: 1300,
                      '@media (max-width: 1440px)': {
                        bottom: '80px',
                        right: '16px',
                      },
                    }}
                  >
                    Notes
                  </Button>,
                  document.body
                )}
            </div>
          </Box>
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default StartUpsProfile;
